import { cn } from '@/lib/utils';

/**
 * 零壹 / Superaios Logo —— 空心圆(零) + 实心条(壹) + 中点(数据流)
 * 来源:docs/Web管理端设计/index.html(顶栏左侧)
 */
export function Logo({ className, size = 28 }: { className?: string; size?: number }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0', className)}
      aria-hidden
    >
      <circle cx="22" cy="32" r="14" fill="none" stroke="currentColor" strokeWidth="6" />
      <rect x="44" y="14" width="8" height="36" rx="2" fill="currentColor" />
      <circle cx="32" cy="32" r="3" fill="currentColor" />
    </svg>
  );
}

export function LogoMark({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center gap-2 text-brand', className)}>
      <Logo size={28} />
      <div className="flex flex-col leading-tight">
        <span className="text-sm font-bold tracking-wide text-ink-0">Superaios</span>
        <span className="text-[10px] uppercase tracking-[0.2em] text-ink-3">cTrader Admin</span>
      </div>
    </div>
  );
}
